import * as React from "react";
import { useState } from "react";
import {
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";
import { BaseModal } from "../../../atoms/base-modal";
import { ProcedureEntity } from "../../../../application/domain/procedures/procedure-entity";
import {
  CsvOutputValueOption,
  SelectableAppMeta,
} from "./csv-output-value-option";
import { CsvOutputValueExpOption } from "./csv-output-value-exp-option";
import { CSVEncoding } from "../../../../application/domain/file-encoding";

interface DownloadSingleCsvModalProps {
  isActive: boolean;
  procedure: ProcedureEntity;
  selectable: SelectableAppMeta;
  onDownloadCsv: () => Promise<void>;
  onClose: () => void;
  encoding: CSVEncoding;
  onChangeCSVEncoding: (encoding: CSVEncoding) => void;
  includeTenantProcessResult: boolean;
  onCheckIncludeTenantProcessResult: (checked: boolean) => void;
  requireSelectableRawValue: boolean;
  onChangeRequireSelectableRawValue: (isRequired: boolean) => void;
}

export const DownloadSingleCsvModal: React.FC<DownloadSingleCsvModalProps> = ({
  isActive,
  procedure,
  selectable,
  onDownloadCsv,
  onClose,
  encoding,
  onChangeCSVEncoding,
  includeTenantProcessResult,
  onCheckIncludeTenantProcessResult,
  requireSelectableRawValue,
  onChangeRequireSelectableRawValue,
}) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  return (
    <BaseModal
      isActive={isActive}
      title="申請内容CSVダウンロード"
      onClose={onClose}
    >
      <section className="modal-card-body">
        <section className="column mb-5">
          <CsvOutputValueOption
            procedure={procedure}
            selectable={selectable}
            includeTenantProcessResult={includeTenantProcessResult}
            onCheckIncludeTenantProcessResult={
              onCheckIncludeTenantProcessResult
            }
            tenantProcessResultSetting={
              procedure.published?.template.tenantProcessResultSetting
            }
          />
        </section>
        <section className="column mb-5">
          <CsvOutputValueExpOption
            encoding={encoding}
            onChangeCSVEncoding={onChangeCSVEncoding}
            requireSelectableRawValue={requireSelectableRawValue}
            onChangeRequireSelectableRawValue={
              onChangeRequireSelectableRawValue
            }
          />
        </section>
      </section>
      <footer className="modal-card-foot is-justify-content-center">
        <SecondaryButton text="キャンセル" onClick={onClose} />
        <PrimaryButton
          text="ダウンロード"
          isLoading={isSubmitting}
          onClick={async (e) => {
            e.preventDefault();
            setIsSubmitting(true);
            await onDownloadCsv();
            setIsSubmitting(false);
            onClose();
          }}
          data-for-rpa-id={"download-csv"}
        />
      </footer>
    </BaseModal>
  );
};
